import { TabsLayout } from "@jugl-web/ui-components";
import { useTranslations } from "@jugl-web/utils";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { CXIntegrationsList } from "./components/CXIntegrationsList";
import { CXAgentSetup } from "./components/CXAgentSetup";

type PageTab = "integrations" | "agent-setup";

export const CXActionsPage: React.FC = () => {
  const location = useLocation();
  const hasPendingConnectionStep = !!(
    location.state as { pendingConnectionStep?: unknown } | null
  )?.pendingConnectionStep;
  const [activeTab, setActiveTab] = useState<PageTab>("integrations");
  const { t } = useTranslations();

  useEffect(() => {
    if (hasPendingConnectionStep) setActiveTab("integrations");
  }, [hasPendingConnectionStep]);

  return (
    <TabsLayout
      breadcrumbProps={{
        items: [
          {
            title: t({
              id: "cx-actions-page.actions",
              defaultMessage: "Actions",
            }),
          },
        ],
      }}
      selectedTab={activeTab}
      tabs={[
        {
          id: "integrations",
          title: t({
            id: "cx-actions-page.integrations",
            defaultMessage: "Integrations",
          }),
          onClick: () => setActiveTab("integrations"),
        },
        {
          id: "agent-setup",
          title: t({
            id: "cx-agent-setup.tab-title",
            defaultMessage: "Agent Setup",
          }),
          onClick: () => setActiveTab("agent-setup"),
        },
      ]}
    >
      {activeTab === "integrations" && <CXIntegrationsList />}
      {activeTab === "agent-setup" && <CXAgentSetup />}
    </TabsLayout>
  );
};
